
import { CompanyModule } from "@/models/company-module";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import {MaxDocumentsMetaData} from "@/models/module-max-documents-meta-data";
import { CompanyService } from "@/services/company-service";
import { Company } from "@/models/company";

export default FormLike.extend({
	data(){
		return {
			maxDocuments: 0,
			madeCount: 0,
			lastDocumentMadeDate: new Date(0)
		};
	},
	props: {
		value: {
			type: Object as ()=>CompanyModule,
			required: true
		},
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.maxDocuments = MaxDocumentsMetaData.create(this.value.metaData).getMaxDocumentsPerMonth();
				this.madeCount = MaxDocumentsMetaData.create(this.value.metaData).getDocumentsMadeCount();
				this.lastDocumentMadeDate = MaxDocumentsMetaData.create(this.value.metaData).getLastDocumentMadeDate();
			}
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async submit(){
			if (!this.isValid) return;
			MaxDocumentsMetaData.create(this.value.metaData).setDocumentsMadeCount(this.maxDocuments)
				.setDocumentsMadeCount(this.madeCount).setLastDocumentMadeDate(this.lastDocumentMadeDate);
			await CompanyService.updateModuleOfCompany(this.company, this.value.id, this.value.metaData);
			this.$emit("saved", this.value);
			this.$emit("close");
		}
	}
});
